import {
    Form, CheckInput, DateInput, ListInput, FormSubmitHandler, FormButton, FormButtonContainer, FormItem,
    OptionProps, SelectInput, SwitchInput, TextInput, useAlerts, useForm,
    RadioGroupInput, SliderInput, TimeInput, DateTimeInput, MaskedInput
} from "@sis/react-library"
import { Box, ListItemIcon, ListItemText } from "@mui/material";
import ForwardIcon from '@mui/icons-material/Forward';
import { ExampleDto } from "./FormSamplesDisableFormPage";
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp';

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends ExampleDto { }

interface FormSamplesDisableFormFormProps {
    initialValues: ExampleDto;
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesDisableFormForm = ({
    initialValues, onSubmit, submitting
}: FormSamplesDisableFormFormProps) => {

    const formName = 'FormDisableForm';

    const selectOptions: OptionProps[] = [
        { value: "Op1", description: "Option 1", filter: "Option 1" },
        { value: "Op2", description: "Option 2", filter: "Option 2" },
        { value: "Op3", description: "Option 3", filter: "Option 3" },
        { value: "Op4", description: "Option 4", filter: "Option 4" }
    ]

    const { resetForm } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    const multiListRender = (option: OptionProps) => {
        return <>
            <Box sx={{ width: '26px', paddingTop: '4px' }}><ListItemIcon><ForwardIcon /></ListItemIcon></Box>
            <ListItemText
                sx={{ color: (option.description as string).indexOf('2') > 0 ? 'blue' : undefined }}
            >
                {option.description}
            </ListItemText>
        </>
    }

    return (
        /////////////////////////////////////////////////////////////////////////////////////////////
        // All controls support a disabled prop
        // To disable the whole form add the disableForm prop to the Form component like below
        /////////////////////////////////////////////////////////////////////////////////////////////        
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            initialValues={initialValues}
            disableForm
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
        >
            <FormItem<T>
                formField="textBox"
                label="Text Box"
                element={<TextInput />}
            />
            <FormItem<T>
                formField="date"
                label="Date"
                element={<DateInput />}
            />
            <FormItem<T>
                formField="time"
                label="Time"
                element={<TimeInput />}
            />
            <FormItem<T>
                formField="dateTime"
                label="Date Time"
                element={<DateTimeInput />}
            />
            <FormItem<T>
                formField="singleSelect"
                label="Single Select"
                element={<SelectInput options={selectOptions} />}
            />
            <FormItem<T>
                formField="multipleSelect"
                label="Multiple Select"
                element={<SelectInput isMultiSelect options={selectOptions} />}
            />
            <FormItem<T>
                formField="singleList"
                label="Single List"
                element={<ListInput options={selectOptions} />}
            />
            <FormItem<T>
                formField="multipleList"
                label="Multiple List"
                element={
                    <ListInput
                        isMultiSelect
                        options={selectOptions}
                        // You can override the list render if you like. This makes the option blue if it has a 2 in it.
                        itemRender={multiListRender}
                    />
                }
            />
            <FormItem<T>
                formField="radioGroup"
                label="Radio Group"
                element={<RadioGroupInput row options={selectOptions} />}
            />
            <FormItem<T>
                formField="slider"
                label="Slider"
                element={<SliderInput leftIcon={<VolumeDown />} rightIcon={<VolumeUp />} />}
            />
            <FormItem<T>
                formField="switch"
                label="Switch"
                element={<SwitchInput />}
            />
            <br />
            <FormItem<T>
                formField="check"
                label="Check Box"
                element={<CheckInput />}
            />
            <FormItem<T>
                formField="maskTelephone"
                label="Mask Phone Number"
                element={<MaskedInput maskedType="PhoneNumber" />}
            />
            <FormItem<T>
                formField="maskOther"
                label="Mask Other"
                element={<MaskedInput mask="(000) (000)" />}
            />
            <FormButtonContainer>
                <FormButton
                    formButtonText='Cancel'
                    onClick={() => { handleCancel() }}
                />
                <FormButton
                    formButtonText='Submit'
                    submitButton
                />
            </FormButtonContainer>
        </Form>
    )
}